import { ComponentType, HTMLAttributes, memo } from 'react';

import { cn } from '@growtherapy/sprout-ui';

import type { ContainerComponentProps } from '../video-sdk/core/types';

export type StageContainerProps = {
  children: React.ReactNode;
  className?: string;
  rounded?: boolean;
  isDarkTheme: boolean;
  videoContainerComponent: ComponentType<ContainerComponentProps>;
} & HTMLAttributes<HTMLDivElement>;

/**
 * The container for the center area in the waiting room and meeting rooms
 */
export const StageContainer = memo(function StageContainer({
  children,
  className,
  rounded,
  isDarkTheme,
  videoContainerComponent: VideoContainer,
  ...otherProps
}: StageContainerProps) {
  return (
    <VideoContainer
      styleOverride={{ display: 'flex' }}
      className={cn(
        {
          'sm:rounded-2xl border-neutral-800 border rebrand:border-border-state-selected-emphasis': rounded,
          'bg-neutral-300 rebrand:bg-surface-default': !isDarkTheme,
          'bg-neutral-800 rebrand:bg-surface-inverse': isDarkTheme,
        },
        'overflow-hidden relative flex flex-col items-center flex-grow justify-center',
        className,
      )}
      {...otherProps}
    >
      {children}
    </VideoContainer>
  );
});
